
@switch (columnId) {
  @case ('token') {
    <lib-text-table-column>
      {{ element?.token }}
    </lib-text-table-column>
  }
  @case (AdjustmentOrderBy.AdjustmentDate) {
    <lib-date-time-label [dateUtc]="element.adjustmentDate" [rawDateWithNoTime]="true"></lib-date-time-label>
  }
  @case (AdjustmentOrderBy.Amount) {
    <lib-text-table-column>
      {{ element?.amount | vituCurrencyUsd }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.amount ?? 0"></lib-table-column-sort>
  }
  @case (AdjustmentOrderBy.CreatedDate) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case (AdjustmentOrderBy.Reason) {
    <lib-text-table-column>
      {{ element?.reason | spaceBetweenCaps }}
    </lib-text-table-column>
  }
  @case (AdjustmentOrderBy.MID) {
    <lib-text-table-column>
      {{ element?.mid }}
    </lib-text-table-column>
  }
  @case (AdjustmentOrderBy.FundingDeposit) {
    <lib-text-table-column>
      {{ element?.fundingDepositsRef }}
    </lib-text-table-column>
  }
  @case ('type') {
    <lib-text-table-column>
      {{ element?.type | spaceBetweenCaps }}
    </lib-text-table-column>
  }
  @case ('description') {
    <lib-text-table-column>
      {{ element?.description }}
    </lib-text-table-column>
  }
  @default {
  }
}
